import { ContractReturnRequestModel } from "./contract-return-request-model";
import { PaymentsRequestModel } from "./PaymentRequestModel";
import { VoucherRequest } from "./voucher-request";


export class ContractReturnRequestCompleteModel {
    contractReturnRequestModel: ContractReturnRequestModel;
    voucherCreateRequest: VoucherRequest;
    paymentsRequestModel: PaymentsRequestModel;
    customerCode: string;
    constructor() {
        this.contractReturnRequestModel = new ContractReturnRequestModel();
        this.voucherCreateRequest = new VoucherRequest();
        this.paymentsRequestModel = new PaymentsRequestModel();
        this.customerCode = "";
    }
}